module.exports = __webpack_public_path__ + "img/tob_12.abb8cf5c.svg";